/**
 * Guards the optionId function from undefined access error.
 *
 * @param optionId the user supplied optionId function.
 * @returns {function(*=): *} guarded optionId function.
 */
const guardOptionId = optionId => option => (optionId && option ? optionId(option) : option);

export default guardOptionId;
